<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p48"><span><a href="#/Contents#rp48">FRESH MOREL SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Make this elegant soup with any fragrant wild mushroom, or a mixture of mushrooms.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>1½ cups chopped morel mushrooms</span></p>
<p class="hang"><span>1–2 teaspoons margarine or butter</span></p>
<p class="hang"><span>1 quart reduced-sodium fat-free beef broth</span></p>
<p class="hang"><span>1 cup water</span></p>
<p class="hang"><span>1–2 tablespoons dry sherry (optional)</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>Crumbled blue cheese, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Cook mushrooms in margarine in medium saucepan over medium heat until lightly browned, about 5 minutes. Add broth and water and heat to boiling; reduce heat and simmer, uncovered, 15 minutes. Stir in sherry; season to taste with salt and pepper. Sprinkle each bowl of soup with blue cheese.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 35</span></p>
<p class="per1"><span>% calories from fat: 26</span></p>
<p class="per1"><span>Protein (g): 5.6</span></p>
<p class="per1"><span>Carbohydrate (g): 1.2</span></p>
<p class="per1"><span>Fat (g): 1.1</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 172</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.5</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0229.vue?4354775f